import styled from 'styled-components'
import colors from 'globals/colors'

interface MailDetailsTitleProps {
  noMargin?: boolean
}

interface AddTrackingNumberProps {
  marginTop?: boolean
}

interface AnchorExtendedProps {
  disabled?: boolean
}

export const MailDetailsTitle = styled.div<MailDetailsTitleProps>`
  line-height: 51px;
  font-size: 18px;
  font-weight: bold;
  margin-top: ${(props) => (props.noMargin ? '0' : '75px')};
`

export const MailDetailsScan = styled.img`
  max-height: 200px;
  filter: drop-shadow(0px 2px 8px rgba(196, 196, 196, 0.5));
  margin: 11px 0 62px;
  &:hover {
    cursor: pointer;
  }
`

export const MailDetailsData = styled.div`
  line-height: 19px;
  font-size: 14px;
  margin-bottom: 20px;

  & > span {
    color: ${colors.steelGrey};
  }
`
export const ModifyTrackingNumber = styled.a`
  color: ${colors.waterBlue};
  margin-left: 8px;
`

export const AddTrackingNumber = styled.div<AddTrackingNumberProps>`
  width: 100%;
  margin-bottom: 20px;
  ${(props) => props.marginTop && 'margin-top: 16px'}
`

export const MailDetailsActions = styled.a<AnchorExtendedProps>`
  line-height: 19px;
  color: ${colors.darkGrey};
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 20px;
  display: block;

  ${(props) => (props.disabled ? 'pointer-events: none; cursor: default;' : '')}
`

export const MailDetailsDeleteLine = styled.a<AnchorExtendedProps>`
  line-height: 19px;
  color: ${colors.waterBlue};
  font-size: 14px;
  font-weight: bold;
  margin-top: 30px;

  & > span {
    text-decoration: underline;
  }

  & > svg {
    margin-left: 6px;
  }

  ${(props) => (props.disabled ? 'pointer-events: none; cursor: default;' : '')}
`
export const DestroyParcel = styled.a<AnchorExtendedProps>`
  line-height: 19px;
  color: ${colors.waterBlue};
  font-size: 14px;
  font-weight: bold;
  margin-top: 16px;

  & > span {
    text-decoration: underline;
  }

  ${(props) => (props.disabled ? 'pointer-events: none; cursor: default;' : '')}
`
